module.exports = __webpack_public_path__ + "img/rollNum.8e3a3188.png";